import { render, staticRenderFns } from "./WaitinglistEvent.vue?vue&type=template&id=98939b78&"
import script from "./WaitinglistEvent.vue?vue&type=script&lang=js&"
export * from "./WaitinglistEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports